import { stableKey } from '../../../lib';

export const sitePreviewKeys = {
  all: stableKey(['sitePreview']),
  querySites: (metaSiteId: string) => stableKey(['sitePreview', 'querySites', metaSiteId]),
};
